import { isPlatformBrowser } from '@angular/common';
import {
    Directive,
    effect,
    inject,
    input,
    OnDestroy,
    PLATFORM_ID,
} from '@angular/core';

@Directive({
    selector: '[dynamicHeaderPage]',
    standalone: true,
})
export class DynamicHeaderPageDirective implements OnDestroy {
    pageDataLoaded = input.required<boolean>();
    dynamicHeaderPage = input.required<boolean>();

    private readonly platformId = inject(PLATFORM_ID);
    private readonly isBrowser = isPlatformBrowser(this.platformId);

    private boundScrollHandler?: () => void;
    private boundResizeHandler!: () => void;
    private resizeTimeout: any;

    constructor() {
        if (!this.isBrowser) return;
        effect(() => {
            if (!this.isBrowser) return;
            if (this.pageDataLoaded()) {
                if (
                    document.querySelectorAll('lib-babylon-engine').length > 1
                ) {
                    document.querySelector('lib-babylon-engine')?.remove();
                }
                this.manageStickyElements();
            }
        });

        this.boundResizeHandler = () => {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(() => {
                this.manageStickyElements();
            }, 300);
        };
        window.addEventListener('resize', this.boundResizeHandler);
        window.addEventListener('mouseup', this.boundResizeHandler);
    }

    ngOnDestroy(): void {
        if (!this.isBrowser) return;

        window.removeEventListener('resize', this.boundResizeHandler);
        window.removeEventListener('mouseup', this.boundResizeHandler);
        if (this.boundScrollHandler) {
            window.removeEventListener('scroll', this.boundScrollHandler);
        }
    }

    manageStickyElements(): void {
        if (!this.isBrowser) return;
        setTimeout(() => {
            // 📌 Verificamos si hay cabeceras especiales
            const headersToCheck = ['#headerBookShow', '#headerCenterBookShow'];
            const hasTopSlider = !!(
                document.querySelector('lib-babylon-top-slider') ||
                document.querySelector('lib-babylon-top-slider-thumbs') ||
                document.querySelector('lib-babylon-top-slider-video')
            );
            let validator = false;

            headersToCheck.forEach((selector) => {
                if (document.querySelector(selector)) {
                    validator = true;
                    // 👉 aquí puedes añadir más lógica específica para cada cabecera si necesitas
                }
            });

            // 💡 Comportamiento especial para headerCenterBookShow
            if (document.querySelector('#headerCenterBookShow')) {
                document
                    .querySelector('.babylon__engine')
                    ?.classList.add('header-center-bookshow-engine');
            }

            if (document.querySelector('#headerBookShow')) {
                document
                    .querySelector('.babylon__engine')
                    ?.classList.add('header-bookshow-engine');
            }

            // Sticky Header OK
            if (this.dynamicHeaderPage()) {
                if (
                    document.querySelector(
                        '.header-desktop-container'
                    ) as HTMLElement
                ) {
                    (
                        document.querySelector(
                            '.header-desktop-container'
                        ) as HTMLElement
                    ).style.opacity = '1';
                }

                // 🔁 Eliminar listener anterior si existe
                if (this.boundScrollHandler) {
                    window.removeEventListener(
                        'scroll',
                        this.boundScrollHandler
                    );
                } else {
                    this.boundScrollHandler = this.manageScroll.bind(
                        this,
                        validator,
                        hasTopSlider
                    );
                }

                window.addEventListener('scroll', this.boundScrollHandler);
                window.dispatchEvent(new Event('scroll')); // Trigger scroll to apply initial state
            } else {
                if (this.boundScrollHandler) {
                    window.removeEventListener(
                        'scroll',
                        this.boundScrollHandler
                    );
                }
                document.body.classList.add('header_sticky');
                document.querySelectorAll('.fixed_header')?.forEach((el) => {
                    el.classList.add('header-sticky', 'cs_gescout_sticky');
                });
                if (validator) {
                    document
                        .querySelector('.babylon__engine')
                        ?.classList.add('engine-sticky');
                }
                if (validator) {
                    document
                        .querySelector('.babylon__header__box')
                        ?.appendChild(
                            document.querySelector('lib-babylon-engine')!
                        );
                }
                (
                    document.querySelector(
                        '.header-desktop-container'
                    ) as HTMLElement
                ).style.opacity = '1';
            }
        }, 0);
    }

    manageScroll(validator: boolean, hasTopSlider: boolean): void {
        if (!this.isBrowser) return;
        if (window.scrollY > 100) {
            document.querySelectorAll('.fixed_header')?.forEach((el) => {
                el.classList.add('header-sticky', 'cs_gescout_sticky');
            });
            if (hasTopSlider) {
                document.body.classList.add('has_topslider');
            } else {
                document.body.classList.remove('has_topslider');
            }
            if (validator) {
                document
                    .querySelector('.babylon__engine')
                    ?.classList.add('engine-sticky');
            }
            document.body.classList.add('header_sticky');

            if (validator) {
                document
                    .querySelector('.babylon__header__box')
                    ?.appendChild(
                        document.querySelector('lib-babylon-engine')!
                    );
            }
        } else {
            document.querySelectorAll('.fixed_header')?.forEach((el) => {
                el.classList.remove('header-sticky', 'cs_gescout_sticky');
            });
            if (validator) {
                document
                    .querySelector('.babylon__engine')
                    ?.classList.remove('engine-sticky');
            }
            document.body.classList.remove('header_sticky');

            if (validator) {
                document
                    .querySelector('.top-container')
                    ?.appendChild(
                        document.querySelector('lib-babylon-engine')!
                    );
            }
            document.body.classList.remove('has_topslider');
        }

        if (window.innerWidth >= 1024) {
            const element = document.getElementById('babylon__gallery-slider');
            let positionGallery = (element?.offsetTop ?? 200) - 200;

            if (window.scrollY >= positionGallery) {
                document
                    .querySelector(
                        '.babylon__gallery-slider .babylon__gallery-slider--content'
                    )
                    ?.classList.remove('no-active');
            } else {
                document
                    .querySelector(
                        '.babylon__gallery-slider .babylon__gallery-slider--content'
                    )
                    ?.classList.add('no-active');
            }
        }
    }
}
